import { css } from '@linaria/core';
import media from '../primitives/Media';
export const LegacyTeaserLabel = {
    base: css `
		position: relative;

		display: inline-block;

		margin-right: 4px;
		padding: 2px 4px;

		color: rgb(var(--brand-text-secondary));
		text-transform: uppercase;

		background: rgb(var(--brand-dark-secondary));

		transition: opacity 200ms var(--global-ease-out);
	`,
};
export const Line = {
    base: css `
		overflow: hidden;
		display: block;
		text-overflow: ellipsis;
		white-space: nowrap;
	`,
};
export const BottomArea = {
    base: css `
		position: absolute;
		bottom: 0;
		left: 0;

		display: flex;
		flex-wrap: wrap;

		box-sizing: border-box;
		width: 100%;
		padding: 40px 16px 16px 16px;
		/* ToDo: replace by global color CSS variable when in design system available (hex & rgb) */
		background: linear-gradient(to bottom, rgba(0, 0, 0, 0) 40%, rgba(0, 0, 0, 0.8) 100%);

		transition: all 150ms var(--global-ease-in);
	`,
    textAlignment: {
        left: null,
        right: null,
        center: css `
			padding-bottom: 20px;
		`,
    },
};
export const Info = {
    base: css `
		float: left;
		width: 100%;

		.${LegacyTeaserLabel.base} {
			@media (hover: hover) and (pointer: fine) {
				opacity: 0;
			}
		}

		h2 {
			color: rgb(var(--global-text)) !important;
		}
	`,
    teaserType: {
        media: null,
        text: null,
        collection: null,
        card: null,
        show: null,
        live: null,
        picture: null,
        program: css `
			width: 80%;

			${media('max', 'l')} {
				width: 100%;
			}
		`,
        programWithTextPositionOnImage: css `
			& {
				width: 100%;
			}
		`,
    },
};
